<div
  [hidden]="!showStep"
  [@openClose]="showStep ? 'open' : 'closed'"
  class="wizard-step-wrapper"
  >
  <div class="form-step">
    <div class="form-step__body">
      @if (!hideHeader) {
        <h2 class="form-step__header" data-testid="check-in-header">
          {{ stepTitle }}
        </h2>
      }
      <ng-content></ng-content>
    </div>
  </div>
</div>
